
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 9c0-.522.449-1.263 1.79-1.934C8.072 6.426 9.912 6 12 6s3.928.425 5.21 1.066C18.55 7.736 19 8.478 19 9s-.449 1.263-1.79 1.934C15.928 11.574 14.088 12 12 12s-3.928-.425-5.21-1.066C5.45 10.264 5 9.522 5 9zm7-5c-2.33 0-4.49.47-6.104 1.277C4.342 6.054 3 7.313 3 9c0 1.687 1.342 2.946 2.896 3.723C7.51 13.53 9.669 14 12 14c2.33 0 4.49-.47 6.104-1.277C19.658 11.946 21 10.687 21 9c0-1.687-1.342-2.946-2.896-3.723C16.49 4.47 14.331 4 12 4zM5 15a1 1 0 10-2 0c0 .814.381 1.51.91 2.057.523.542 1.233.984 2.032 1.334 1.602.7 3.744 1.109 6.058 1.109 2.314 0 4.456-.408 6.058-1.109.799-.35 1.509-.792 2.032-1.334.529-.546.91-1.243.91-2.057a1 1 0 10-2 0c0 .152-.066.376-.348.667-.286.296-.748.608-1.396.892-1.294.566-3.151.941-5.256.941-2.105 0-3.962-.375-5.256-.941-.648-.284-1.11-.596-1.396-.892C5.066 15.377 5 15.152 5 15z","fill":"currentColor"}})])
          )
        }
      }
    